<template>
  <transition name="modal">
    <div class="l-modal-mask" @click="closeOnBackdrop">
      <div class="l-modal-wrapper">
        <div :class="containerClass">
          <div :class="header">
            <slot name="header">
              default header
            </slot>
            <slot name="close">
              <span class="l-modal-close" @click.prevent="$emit('close')">
                <button class="btn btn-close"><span class="mod-icon-close" /></button>
              </span>
            </slot>
          </div>

          <div :class="[body]">
            <slot name="body">
              default body
            </slot>
          </div>

          <div :class="footer">
            <slot name="footer">
              <div class="row">
                <div class="col-12">
                  <button type="button" class="btn btn-primary pull-right ld-ext-right"
                          :class="loadingButton ? 'running' : ''"
                          :disabled="buttonDisabled"
                          @click="$emit('ok')"
                  >
                    Save
                    <div class="ld ld-ball ld-flip" />
                  </button>
                </div>
              </div>
              <div class="clearfix" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '',
    },
    container: {
      type: String,
      default: '',
    },
    header: {
      type: String,
      default: 'l-modal-header',
    },
    body: {
      type: String,
      default: 'l-modal-body',
    },
    footer: {
      type: String,
      default: 'l-modal-footer',
    },
    closeStrict: {
      type: Boolean,
      default: true,
    },
    loadingButton: {
      type: Boolean,
      default: false,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    containerClass() {
      let style = '';
      if (this.size.length) style = `${this.size} `;
      style += this.container.length ? this.container : 'l-modal-container';
      return style;
    },
  },
  mounted() {
    window.addEventListener('keydown', this.keydown, false);
    document.querySelector('body').style.overflow = 'hidden';
  },
  destroyed() {
    window.removeEventListener('keydown', this.keydown, false);
    document.querySelector('body').style.overflow = 'auto';
  },
  methods: {
    closeOnBackdrop(event) {
      if (!this.closeStrict) {
        if (event.target.className === 'l-modal-wrapper') {
          this.$emit('close');
        }
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue